import React from 'react';
import { withRouter } from 'react-router-dom';
// ANTD
import Menu from 'antd/lib/menu';
import Dropdown from 'antd/lib/dropdown';
import Icon from 'antd/lib/icon';
import message from 'antd/lib/message';
import ClipboardButton from 'react-clipboard.js';
//

import QuestionnairePreview from '../QuestionnairePreview';

const ICON_STYLE = { marginRight: 6, fontSize: 17 };

class ActionMenu extends React.PureComponent {
  state = {
    loading: false,
    visible: false,
    selected: null,
  };

  onCancel = () => {
    this.setState({ visible: false, selected: null });
  };

  shareLink = () => {
    const { record } = this.props;
    console.log(process.env);
    message.success(
      `Share this link: ${process.env.REACT_APP_PUBLIC_URL}blank/complete-questionnaire/${record._id}`,
      15,
    );
  };

  handleMenuClick = ({ key }) => {
    switch (key) {
    case '1':
      return this.setState({ visible: true, selected: this.props.record });
    case '2':
      return null;
    default:
      return null;
    }
  };

  render() {
    return (
      <div style={s.container}>
        <Dropdown
          trigger={['click']}
          overlay={(
            <Menu onClick={this.handleMenuClick}>
              <Menu.Item key="1">
                <Icon type="file-text" style={ICON_STYLE} />
                View
              </Menu.Item>
              <Menu.Item key="2">
                <ClipboardButton
                  component="span"
                  onSuccess={() => message.success(
                    `Link copied to clipboard: ${`${process.env.REACT_APP_PUBLIC_URL}blank/complete-questionnaire/${
                      this.props.record._id
                    }`}`,
                    10,
                  )
                  }
                  data-clipboard-text={`${process.env.REACT_APP_PUBLIC_URL}blank/complete-questionnaire/${
                    this.props.record._id
                  }`}
                >
                  <Icon type="share-alt" style={ICON_STYLE} />
                  Share Link
                </ClipboardButton>
              </Menu.Item>
            </Menu>
          )}
        >
          {this.state.loading ? (
            <Icon type="loading" style={s.loadingIcon} />
          ) : (
            <Icon type="ellipsis" style={{ fontSize: 20, fontWeight: 600 }} />
          )}
        </Dropdown>
        <QuestionnairePreview
          onCancel={this.onCancel}
          onOk={this.onCancel}
          selected={this.state.selected}
          visible={this.state.visible}
        />
      </div>
    );
  }
}

const s = {
  loadingIcon: {
    fontSize: 20,
    color: '#f29980',
    fontWeight: 600,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};

export default withRouter(ActionMenu);
// export default compose(withRouter())(withRouter(ActionMenu));



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientQuestionnaires/ActionMenu/index.js